import { AuthContextProps } from 'context/AuthContextProps';
import { createContext } from 'react';


export const AuthContext = createContext<AuthContextProps | undefined>(undefined);


